
import { RevButton } from '@ds/components/Button'
import { mapGetters } from 'vuex'

import Block from '@internal-reviews/components/Block'
import { ROUTES } from '@router'
import { trackClick } from '@tracking/events'

import translations from './Reviews.translations'

export default {
  name: 'Reviews',
  components: {
    RevButton,
    Block,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    reviews: { type: Array, required: true },
    rate: { type: Object, required: true },
    summary: { type: Object, required: true },
  },
  computed: {
    ...mapGetters({
      country: 'config/country',
    }),
    reviewPage() {
      return {
        type: 'internal',
        name: ROUTES.REVIEWS.PAGES.LANDING,
        params: {
          landingSlug: this.$route.params.slugV2,
          landingId: this.$route.params.uuid,
        },
      }
    },
    translations() {
      return translations
    },
  },
  methods: {
    clickSeeMoreReviews() {
      trackClick({
        name: 'see_all_reviews',
        pageType: this.$route.name,
      })
    },
  },
}
